export default __webpack_public_path__ + "static/media/iphone15pro.a6ea4150cb04b729112a2573ca83109f.png";